import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfUTIProbabilidadeInternacao = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : ''); 

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Probabilidade de UTI',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon '+theme}><img src={"/img/icon_printer"+textIcon+".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{marginTop: '40px',marginLeft: '80px', marginRight: '80px'}}>
            <div className="inforow right">
              <h3 style={{fontSize: '18px'}}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{width: '12vw', position:'relative', marginLeft: '32px', float: 'right'}}/>
							{
								BACKEND_URL.includes('gruposanta') ? (
									<img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
								) : null
							}
            </div>
          </div>
          <div className="inforow" style={{marginLeft: '80px', marginRight: '80px'}}>
            <div className='inforow right'>
              <div className='infoText' style={{fontSize: '12px'}}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{fontSize: '12px'}}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                <th>Atendimento</th>
                <th>Paciente</th>
                <th>Setor</th>
                <th>Especialidade</th>
                <th>Probabilidade</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let color = '';
                  let colorProbabilidade = '';
                  let statusClass = "ready";
                  let situacao = data.previsaouti + ' %';
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let nascimento = moment(data.nascimentopaciente).format('DD/MM/YYYY');;
                  let name = data.nomepaciente.split(' ').slice(-1).join(' ') + ', ' + data.nomepaciente.split(' ')[0].slice(0, 1);
                  let codAtendimento = data.codigoatendimento;
                  let especialidade = data.descricaoespecialidade;
                  let setor = data.descricaosetor;
                  let key = "tr-" + data.codigoatendimento;

                  if (data.previsaouti <= 25) {
                    colorProbabilidade = '#888888';
                    statusClass = "scheduled";
                  } else if (data.previsaouti > 25 && data.previsaouti <= 50) {
                    statusClass = 'waiting';
                    colorProbabilidade = '#ff771d';
                  } else if (data.previsaouti > 50) {
                    statusClass = 'canceled';
                    colorProbabilidade = '#cc0000';
                  } else {
                    statusClass = "progress";
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ color: color }} align="left">{codAtendimento}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"  ><b>{name}</b> | {nascimento}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{setor}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{especialidade}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: colorProbabilidade }} align="left"  ><b>{situacao}</b></td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfUTIProbabilidadeInternacao;